import React, { Component } from 'react';
import { FaSignOutAlt } from 'react-icons/fa';
import { signOut } from 'lib/AuthClient/authentication';

import './SignOut.scss';

export default class SignOut extends Component {
  signOut = async () => {
    await signOut();
    window.location.href = '/';
  };

  render() {
    return (
      <button className="signOutButton" onClick={this.signOut}>
        <FaSignOutAlt />
        <span className="visually-hidden">Sign out</span>
      </button>
    );
  }
}
